import { useWindowSize } from '@websolutespa/bom-mixer-hooks';
import { clamp, LlmBlock } from '@websolutespa/bom-mixer-llm';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { useRef } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CustomCard, LlmChunkCustomCard } from '../CustomCard/custom-card';
import style from './custom-card-group.module.scss';

export type LlmChunkCustomCardGroup = {
  type: 'customCardGroup';
  id: string;
  items: LlmChunkCustomCard[];
};

export const CustomCardGroup: React.FC<LlmBlock<LlmChunkCustomCardGroup>> = (props) => {
  const { item } = props;

  useWindowSize();

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const swiperProps = {
    modules: [Navigation],
    spaceBetween: clamp(16, 24),
    slidesPerView: 1.1,
    watchOverflow: true,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current,
    },
    breakpoints: {
      630: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2.5,
      },
      1280: {
        slidesPerView: 3,
      },
    },
  };

  return (
    <div className={style.customCardGroup}>
      <Swiper {...swiperProps}>
        <div className={style.customCardGroupNav}>
          <button ref={navigationPrevRef}><ArrowLeftIcon /></button>
          <button ref={navigationNextRef}><ArrowRightIcon /></button>
        </div>
        {item.items.map((item, i) => (
          <SwiperSlide key={i} className={style.customCardGroupSlide}>
            <CustomCard {...props} item={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

